import { BRAND } from "../../type/EnumBrand";
import { IBrand } from "../../type/IBrand";

export const prismsound: IBrand = {
  id: "prism-sound",
  name: BRAND.PRISM_SOUND,
  logo: "/logo/prism-sound-logo.png",
  website: "https://beta.prismsound.com/",
  description: `
An industry leader in high quality audio conversion. Innovating with rack mounted customizable interfaces. 
  `
}